import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://placeworthy.ca";

export default function Seo({ title, description, path = "", image, jsonLd }) {
  const fullTitle = title ? `${title} | Placeworthy` : "Placeworthy | The guide to places worth experiencing";
  const url = `${SITE}${path}`;
  const desc = description || "Placeworthy — the independent guide to restaurants, bars, cafés and experiences worth your time.";
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {image && <meta name="twitter:image" content={image} />}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
